function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import { withRouter, Route, Redirect } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import Upgrade from '../../pages/Upgrade/Container';

var RR =
/*#__PURE__*/
function (_React$Component) {
  _inherits(RR, _React$Component);

  function RR() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, RR);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(RR)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      loaded: false,
      isAuthenticated: false
    };
    return _this;
  }

  _createClass(RR, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.authenticate();
      this.unlisten = this.props.history.listen(function () {
        Auth.currentAuthenticatedUser().then(function (user) {
          // eslint-disable-next-line no-console
          console.log('R O L E A U T H E N T I C A T E D ', user);
        }).catch(function () {
          if (_this2.state.isAuthenticated) _this2.setState({
            isAuthenticated: false
          });
        });
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unlisten();
    }
  }, {
    key: "authenticate",
    value: function authenticate() {
      var _this3 = this;

      Auth.currentAuthenticatedUser().then(function (user) {
        var payload = user.signInUserSession.idToken.payload;
        var groups = payload['cognito:groups'];
        var userRole = groups ? groups[0] : payload['custom:initialRole'];
        var active = user.attributes['custom:active'];
        var institution_type = user.attributes['custom:institution_type'];
        var users_country = user.attributes['custom:country'];

        _this3.setState({
          loaded: true,
          isAuthenticated: true,
          userRole: userRole,
          active: active,
          institution_type: institution_type,
          users_country: users_country
        });
      }).catch(function (err) {
        // eslint-disable-next-line no-console
        console.log(err);

        _this3.setState({
          loaded: true,
          isAuthenticated: false
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          Component = _this$props.component,
          allowedRoles = _this$props.allowedRoles,
          redirect = _this$props.redirect,
          rest = _objectWithoutProperties(_this$props, ["component", "allowedRoles", "redirect"]);

      var _this$state = this.state,
          loaded = _this$state.loaded,
          isAuthenticated = _this$state.isAuthenticated,
          userRole = _this$state.userRole,
          active = _this$state.active,
          users_country = _this$state.users_country,
          institution_type = _this$state.institution_type;
      if (!loaded) return null;
      return React.createElement(Route, _extends({}, rest, {
        render: function render(props) {
          return isAuthenticated && allowedRoles.includes(userRole) && active ? React.createElement(Component, _extends({
            institution_type: institution_type,
            users_country: users_country,
            userRole: userRole,
            active: active
          }, props, rest)) : isAuthenticated && allowedRoles.includes(userRole) && !active ? React.createElement(Upgrade, _extends({
            institution_type: institution_type,
            users_country: users_country,
            userRole: userRole,
            active: active
          }, rest, props)) : isAuthenticated && !allowedRoles.includes(userRole) ? React.createElement(Redirect, {
            to: {
              pathname: redirect
            }
          }) : !isAuthenticated ? React.createElement(Redirect, {
            to: {
              pathname: 'login'
            }
          }) : '';
        }
      }));
    }
  }]);

  return RR;
}(React.Component);

export var RoleRoute = withRouter(RR);